import {ResidenceService} from "../../service/residence/ResidenceService";
import React, {useEffect, useState} from "react";
import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCustomTable,
    RaikoDefaultDialogPage, RaikoGridFourColumn,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoSearchInputOutlined,
    RaikoSectionContainer,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useNavigate, useSearchParams} from "react-router-dom";
import ResidenceCreateNew from "./addNew/ResidenceCreateNew";
import {createResidenceTableRow, residenceTableHeader} from "./ResidenceHelper";
import {Helmet} from "react-helmet";
import {useDebounce} from "@uidotdev/usehooks";

export default function ResidencesList() {


    let page = 0;
    const size = 30;
    const service = new ResidenceService();

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [residenceList, setResidenceList] = useState([]);
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [selectDisplayType, setSelectDisplayType] = useState(false)

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [title, setTitle] = useState(searchParams.get("title") || "");
    const filterTitle = useDebounce(title, 500)


    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [
        filterTitle,
        page,
    ])


    function getDataFromServer() {
        setIsLoading(true);
        service.getResidence(page, size, filterTitle)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)

                setResidenceList([])
                response.data.map((item, index) => {
                    setResidenceList(prevResidenceList => [
                        ...prevResidenceList,
                        createResidenceTableRow(
                            (page * size) + index + 1,
                            item.id,
                            item.metaData ? item.metaData.title : "-",
                            item.metaData && item.metaData.address ? item.metaData.address.slice(0, 20) + " ..." : "-",
                            item.menCapacity,
                            item.womenCapacity,
                            item.createdAt,
                            item.createdBy,
                            item.metaData && item.metaData.address ? item.metaData.address : "",
                        )
                    ])
                })

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            setIsLoading(false);
        })
    }


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }


    function showResidenceDetail(id) {

        let _title = ""
        residenceList.map((item) => {
            if (item.id === id)
                _title = item.title
        })


        navigate(
            RouteHelper.ResidenceDetail.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function handleAddNewItemToList(item) {
        handleCloseDialog()

        const _items = addNewRowToTable(createResidenceTableRow(
            1,
            item.id,
            item.metaData ? item.metaData.title : "-",
            item.metaData && item.metaData.address ? item.metaData.address.slice(0, 20) + " ..." : "-",
            item.menCapacity,
            item.womenCapacity,
            item.createdAt,
            item.createdBy
        ), residenceList)

        setResidenceList(_items);
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Residences.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <ResidenceCreateNew handleAddNewItemToList={handleAddNewItemToList}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    {
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Habitation.name, ""),
                            raikoBreadCrumbItemGenerator(RouteHelper.Residences.name, ""),
                        ]}/>
                    }
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>

                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اقامتگــاه ها"}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoTableSearchContainer
                            labelText={"نام اقامتگاه"}
                            value={title}
                            setValue={setTitle}
                        />

                        <RaikoCustomTable
                            isLoading={isLoading}
                            data={residenceList}
                            header={residenceTableHeader}
                            handlePaginationChange={handleChangePagination}
                            pageCount={pageCount}
                            rowClicked={showResidenceDetail}
                            selectDisplayType={selectDisplayType}
                        >
                            <RaikoGridThreeColumn className={css`padding: 3px`}>
                                {
                                    residenceList.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            title={item.title}
                                            titleLabel={item.fullAddress}
                                            items={[
                                                RaikoCardInfoTypeOneItemGenerator("ظرفیت آقا", item.menCapacity),
                                                RaikoCardInfoTypeOneItemGenerator("ظرفیت خانم", item.womenCapacity),
                                            ]}
                                            onClick={_ => {
                                                showResidenceDetail(item.id)
                                            }}
                                        />
                                    })
                                }

                            </RaikoGridThreeColumn>
                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoBaseContainer>
        </>
    )

}


